export default "__VITE_ASSET__C8kWiP_a__"